/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
import { Box, maxWidth, width } from '@mui/system';
import React, { useEffect, useState, useCallback } from 'react';
import CTable from 'components/CTable';
import { GLOBAL_DATE_FORMAT, LIST_LIMIT } from 'constant';
import { useLazyGetInProgressListQuery } from 'store/services/activityTimeEntry';
import useAuth from 'hooks/useAuth';
import moment from 'moment';
import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Tooltip } from '@mui/material';
import { Close, DeleteOutlineOutlined, EditTwoTone, VisibilityTwoTone } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { encriptId } from 'utils/encription';
import { useDeleteActivityEntryMutation, useLazyGetActivityTimeDetailsQuery } from 'store/services/activitySetup';

import ConfirmationModal from 'components/reusable/ConfirmationModal';
import useSnackbar from 'hooks/useSnackbar';
import usePermission from 'hooks/usePermission';
import TimeEntryView from './TimeEntryView';
import HistoryIcon from '@mui/icons-material/History';
import HistoryView from './HistoryPopup';

const allyProps = {
    minwidth: 160,
    flex: 1,
    sortable: false
};

const InProgress = ({ filterValues, therapist }) => {
    const { user } = useAuth();
    const [trigger, { data: inProgressData, isFetching: inProgressLoading }] = useLazyGetInProgressListQuery();
    const [triggerActivityTimeDetails, { data: details, isLoading: isDetailLoading, isFetching: isDetailFetching }] =
        useLazyGetActivityTimeDetailsQuery();
    const [list, setList] = useState({ fields: [] });
    const [page, setPage] = useState(1);
    const [timeSheetId, setTimeSheetId] = useState(null);
    const { notify } = useSnackbar();

    const { hasPermission, isTherapist: isRoleTherapist, isSameAsMasterAdmin } = usePermission();
    const isTherapist = isRoleTherapist && !isSameAsMasterAdmin;

    const [view, setView] = useState(null);
    const [viewData, setViewData] = useState(null);

    useEffect(() => {
        setPage(1);
    }, [filterValues]);

    const handleView = async (id) => {
        const details = await triggerActivityTimeDetails({
            client_id: user?.client_id,
            id
        });
        setViewData(details?.data?.fields);
        setView(true);
    };

    const cols = (confirmDelete, handleHistory) => [
        {
            field: 'date',
            headerName: 'Date',
            ...allyProps,
            maxWidth: 120,
            valueGetter: (params) => moment.utc(params?.value).local().format(GLOBAL_DATE_FORMAT)
        },
        {
            field: 'location',
            headerName: 'Location',
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => {
                return params.row.location?.name || '';
            },
            ...allyProps
        },
        {
            field: 'Service',
            headerName: 'Service',
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => {
                return params.row?.service?.service_name || '';
            },
            ...allyProps
        },
        {
            field: 'therapist',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Therapist',
            valueGetter: (params) => params.row.therapist?.name || '',
            ...allyProps
        },
        {
            field: 'total_minutes',
            align: 'center',
            maxWidth: 120,
            headerAlign: 'center',
            headerName: 'Total Minutes',
            valueGetter: (params) =>
                (params.row?.time_entry_details_time_entry || []).reduce((sum, item) => sum + (Number(item?.minutes) || 0), 0) || '',
            ...allyProps
        },

        {
            field: 'actions',
            headerName: 'Actions',
            align: 'center',

            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Stack direction="row" alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
                        {hasPermission(['time_entry_view']) && (
                            <Tooltip title="View">
                                <IconButton title="Unlock" color="primary" onClick={() => handleView(params?.row?.id)}>
                                    <VisibilityTwoTone color="secondary" />
                                </IconButton>
                            </Tooltip>
                        )}

                        {hasPermission(['time_entry_edit']) && (
                            <Tooltip title="Edit Time Sheet">
                                <IconButton color="secondary" onClick={() => {}}>
                                    <Link to={`/edit/activity-time-sheet/${encriptId(params?.row.id)}`}>
                                        <IconButton title="Edit" color="primary">
                                            <EditTwoTone />
                                        </IconButton>
                                    </Link>
                                </IconButton>
                            </Tooltip>
                        )}
                        {hasPermission(['time_entry_view']) && (
                            <Tooltip title="View History">
                                <IconButton color="secondary" size="large" onClick={() => handleHistory(params?.row?.id)}>
                                    <HistoryIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                        {hasPermission(['time_entry_delete']) && (isTherapist ? params?.row?.therapist?.id === user?.emp_id : true) && (
                            <Tooltip title="Delete Time Sheet">
                                <IconButton color="secondary" onClick={() => confirmDelete(params?.row)}>
                                    <DeleteOutlineOutlined />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                );
            },
            ...allyProps
        }
    ];

    const IN_PROGRESS = 8;
    const [remove] = useDeleteActivityEntryMutation();
    const [fetchKey, setFetchKey] = useState(0);
    const [deleteId, setDeleteId] = useState(null);
    const showDeleteModal = (id) => {
        setDeleteId(id);
    };

    const hideDeleteModal = () => {
        setDeleteId(null);
    };

    const payload = {
        filters: {
            ...(user?.client_id && { client_id: user.client_id }),

            ...(filterValues.startDate && {
                start_date: moment(new Date(filterValues.startDate)).startOf('day').utc().format('YYYY-MM-DD HH:mm')
            }),
            ...(filterValues.endDate && {
                end_date: moment(new Date(filterValues.endDate)).endOf('day').utc().format('YYYY-MM-DD HH:mm')
            }),
            ...(filterValues.locations.length > 0 && { location_ids: filterValues.locations }),
            ...(filterValues.service_id.length > 0 && { service_ids: filterValues.service_id }),
            ...(therapist && { therapist_ids: [therapist?.emp_id] }),
            status_ids: [IN_PROGRESS]
        },
        pagination: {
            current_page: page
        }
    };

    useEffect(() => {
        setPage(1); // reset page
        setFetchKey((prev) => prev + 1); // force trigger
    }, [therapist]);

    useEffect(() => {
        trigger(payload);
    }, [filterValues, page, user?.client_id, fetchKey]);

    useEffect(() => {
        if (inProgressData && !inProgressLoading) {
            setList(inProgressData);
        }
    }, [inProgressData, inProgressLoading]);

    const handlePageChange = useCallback((_e, val) => {
        setPage(val);
    }, []);

    const confirmDelete = async () => {
        try {
            const res = await remove({ id: deleteId?.id, ...(user?.client_id && { client_id: user?.client_id }) }).unwrap();
            notify({
                message: res.message,
                severity: 'success'
            });
            trigger(payload);
            hideDeleteModal();
        } catch (error) {
            notify({
                message: error.data?.error?.message || 'Something went wrong',
                severity: 'error'
            });
        }
    };

    const handleDialogClose = () => {
        setView(false);
    };

    const handleHistory = (id) => {
        setTimeSheetId(id);
    };

    const handleHistoryClose = () => {
        setTimeSheetId(null);
    };

    return (
        <Box>
            <Box sx={{ height: 'calc(100vh - 280px)', my: 2 }}>
                <CTable
                    loading={inProgressLoading}
                    rows={list?.fields || []}
                    cols={cols(showDeleteModal, handleHistory)}
                    getRowId={(row) => row?.id}
                    currentPage={page}
                    totalCount={list?.pagination?.total_records || 0}
                    countPerPage={list?.pagination?.records_per_page || LIST_LIMIT}
                    onPageChange={handlePageChange}
                />
            </Box>
            <ConfirmationModal
                open={Boolean(deleteId)}
                handleClose={hideDeleteModal}
                handleConfirm={confirmDelete}
                title="Delete Time Sheet"
                description="Are you sure you want to delete this time sheet ?"
            />
            <Dialog open={view} fullWidth maxWidth="sm">
                <IconButton
                    onClick={() => {
                        handleDialogClose();
                    }}
                    sx={{ position: 'absolute', top: 0, right: 0, m: 1 }}
                >
                    <Close />
                </IconButton>
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{
                        fontSize: '16px'
                    }}
                >
                    Time Sheet Details
                </DialogTitle>
                <DialogContent>
                    <TimeEntryView data={viewData} />
                </DialogContent>
            </Dialog>
            <HistoryView pcId={timeSheetId} handleClose={handleHistoryClose} />
        </Box>
    );
};

export default InProgress;
